
(function () {
  const STORAGE_KEY = 'prestige_wishlist_handles';

  function getWishlist() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const arr = JSON.parse(raw);
      if (Array.isArray(arr)) return arr;
      return [];
    } catch (e) {
      console.warn('Wishlist localStorage error', e);
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      console.warn('Wishlist save error', e);
    }
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function addToWishlist(handle) {
    const list = getWishlist();
    if (!list.includes(handle)) {
      list.push(handle);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    const list = getWishlist().filter(h => h !== handle);
    saveWishlist(list);
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
      return false;
    } else {
      addToWishlist(handle);
      return true;
    }
  }

  function updateButtonState(button, active) {
    if (!button) return;
    if (active) {
      button.classList.add('wishlist-toggle--active');
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', button.dataset.wishlistRemoveLabel || 'Remove from favourites');
    } else {
      button.classList.remove('wishlist-toggle--active');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', button.dataset.wishlistAddLabel || 'Add to favourites');
    }
  }

  function refreshAllButtons() {
    const handles = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      updateButtonState(btn, handles.includes(handle));
    });
    updateWishlistCount();
  }

  function updateWishlistCount() {
    const countEl = document.querySelector('[data-wishlist-count]');
    if (!countEl) return;
    const count = getWishlist().length;
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'inline-flex' : 'none';
  }

  // Click handler (event delegation)
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    const handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    event.preventDefault();

    const nowActive = toggleWishlist(handle);
    updateButtonState(button, nowActive);
    updateWishlistCount();

    // If we are on wishlist page, optionally remove item from DOM
    if (button.hasAttribute('data-remove-on-toggle') && !nowActive) {
      const card = button.closest('[data-wishlist-item]');
      if (card) card.remove();
    }
  });

  // On DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    refreshAllButtons();
    // If we are on /search?view=wishlist without q=, redirect with query built from localStorage
    const isWishlistView = window.location.pathname === '/search' &&
      new URLSearchParams(window.location.search).get('view') === 'wishlist';

    const params = new URLSearchParams(window.location.search);
    const hasQuery = params.has('q');

    if (isWishlistView && !hasQuery) {
      const handles = getWishlist();
      if (handles.length > 0) {
        const q = handles.map(h => `handle:${h}`).join(' OR ');
        params.set('type', 'product');
        params.set('q', q);
        window.location.search = params.toString();
      }
    }
  });

  // Expose a tiny API on window if needed
  window.PrestigeWishlist = {
    getWishlist,
    isInWishlist,
    refreshAllButtons,
    updateWishlistCount
  };
})();
